<ng-container *ngIf="ready">
    <ng-container>
        <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true"
            [actionsTemplate]="actionsButtons"></app-table>
    </ng-container>

    <ng-container *ngIf="empty">
        <div class="text-center">
            <img src="assets/icons/nominas.svg" class="invoiceImage">
            <p style="color: #9e9e9e">No tiene ningún mandato, presione + para crear uno.</p>
        </div>
    </ng-container>

    <button type="button" (click)="create()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
      <mat-icon class="mat-icon-add-custom">add</mat-icon>
    </button>

    <ng-template #actionsButtons let-uid="uid">
        <ul class="custom-class">
            <li (click)="pdf(uid)">
                <a>
                    <mat-icon>dvr</mat-icon>PDF
                </a>
            </li>
            <li (click)="edit(uid)">
                <a>
                    <mat-icon>create</mat-icon>Editar
                </a>
            </li>
            <li (click)="delete(uid)">
                <a>
                    <mat-icon>warning</mat-icon>Borrar
                </a>
            </li>
        </ul>
    </ng-template>

</ng-container>
